import ConnectedPlayers from "./ConnectedPlayers";
import "./connected-players.scss";

export default ConnectedPlayers;
